<app-header></app-header>
<div
    class="app-container"
    cdkScrollable>
    <div class="app-content">
      <div class="container container-side-nav">
        <mat-sidenav-container>
          <!-- Dragged from its trailing edge rather than being turned into a
               resize panel: mat-sidenav-container positions the drawer itself
               and owns the over/backdrop behaviour every page relies on below
               the breakpoint. The edge only writes a width, so all of that is
               left alone. Off on mobile, where the nav is an overlay and its
               width is the screen's business. -->
          <mat-sidenav
              [disableClose]="disableClose()"
              [mode]="sidenavService.mode"
              [opened]="sidenavService.opened"
              (openedChange)="sidenavService.openedChange($event)"
              [fixedInViewport]="true"
              [fsResizeEdge]="'right'"
              [size]="200"
              [min]="160"
              [max]="420"
              [disabled]="sidenavService.isMobile"
              [persist]="'side-nav-width'"
              [label]="'Resize navigation'">
            <div class="sidenav-container">
              <div class="logo">
                <a
                    class="image"
                    routerLink="/home">
                  <app-logo [type]="'light'"></app-logo>
                </a>
              </div>
              <app-page-side-nav-main></app-page-side-nav-main>
              <div class="spacer"></div>
              <app-page-side-nav-bottom></app-page-side-nav-bottom>
            </div>
          </mat-sidenav>
          <mat-sidenav-content>
            <fs-banner [type]="'siteBanner'"></fs-banner>
            <app-navbar></app-navbar>
            <router-outlet></router-outlet>
          </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
  </div>
</div>